<!--
 * @Author: DY
 * @Date: 2024-12-26 10:12:24
 * @LastEditTime: 2024-12-26 10:27:39
 * @Description: 锁定库存
 * @FilePath: \ShiMo_Mobile\src\views\storage\inventoryInquiry\lockInventory.vue
-->
<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="lockInventory commonListStyles">
            <HeaderNav
                header-title="已锁定库存"
                left-icon-name="2"
                right-icon-name="3"
                :extr="{ leftCallBack: swiperright }"
            ></HeaderNav>
            <section>
                <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
                    <van-list
                        v-model="isUpLoading"
                        finished-text="没有更多了!"
                        :finished="finished"
                        @load="onLoad"
                    >
                        <ul class="list">
                            <li class="listItem" v-for="(item,index) in listData" :key="`item_${index}`">
                                <div class="engineeringInfo" @click="openMovingInventory(item)">
                                    <h4 class="itemTitle">
                                        <span class="iconfont iconhetong">出库编号：{{ item.relation_number }}</span>
                                    </h4>
                                    <div class="itemContent">
                                        <p>
                                            <img src="@/assets/images/icons/icon_13@2x.png" alt="">
                                            <span>出库单据类型：{{ item.outstock_type }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_29@2x.png" alt="">
                                            <span>领用部门：{{ item.dept_name }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_8@2x.png" alt="">
                                            <span>出库人：{{ item.locked_user_name }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_46@2x.png" alt="">
                                            <span>物料代码：{{ item.material_code }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_28@2x.png" alt="">
                                            <span>短描述：{{ item.material_short_name }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_16@2x.png" alt="">
                                            <span>出库数量：{{ item.volume_locked }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_7@2x.png" alt="">
                                            <span>出库申请时间：{{ item.locked_start_time }}</span>
                                        </p>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </van-list>
                </van-pull-refresh>
            </section>
        </div>
    </v-touch>
</template>

<script>
import { mixin_list } from '@/assets/mixin/mixin_list';
export default {
    name: 'lock-inventory',
    mixins: [mixin_list],
    beforeRouteLeave(to, from, next) {
        if (to.path === '/inventoryInquiry') {
            this.$store.commit('noKeepAlive', 'lock-inventory');
        }
        next();
    },
    data() {
        return {
            cacheKey: Math.floor(Math.random() * 1000000000000 + 1),
            tableCode: 'material_locked_record',
            requestUrl: '',
        };
    },
    filters: {},
    computed: {},
    watch: {},
    activated() {},
    created() {
        const material_code = this.$route.params.data.MaterialCode;
        const stock_id = this.$route.params.data.StockId;
        this.requestUrl = `/basicplatform/tabledata?material_code=${material_code}&stock_id=${stock_id}`;
    },
    mounted() {},
    methods: {
        swiperright() {
            this.$router.isBack = 1;
            this.$router.push({ path: '/inventoryInquiry' });
        },
    },
};
</script>
<style lang="stylus"></style>
